import { deletePlanningCffApi } from 'api-validations/locutus'
import { getPlanningCffsQueryKey } from 'api-validations/locutus/plan'
import { useOrgCodeOrThrow } from 'shared-ui/active-operation'
import { useApiClient, useMutation, useQueryClient } from 'shared-ui/api-provider'

/**
 * Mutation for deleting a CFF from the Planning section
 */
export const useDeletePlanningCffs = () => {
  const orgCode = useOrgCodeOrThrow()
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ cffIds }: { cffIds: string[] }) => ({
      statuses: (
        await Promise.all(
          cffIds.map((cffId) =>
            apiClient.delete(
              deletePlanningCffApi.pathFor({
                orgCode,
                fieldId: cffId
              })
            )
          )
        )
      ).map(({ status }) => status)
    }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [getPlanningCffsQueryKey, orgCode]
      })
  })
}
